import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export function useUnshareCasoGroupMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      casoId,
      groupId,
    }: {
      casoId: string;
      groupId: string;
    }) => {
      const { error } = await supabase
        .from('caso_group_shares')
        .delete()
        .eq('caso_id', casoId)
        .eq('group_id', groupId);

      if (error) throw error;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ 
        queryKey: ['shared-caso-groups', variables.casoId] 
      });
      queryClient.invalidateQueries({ 
        queryKey: ['shared-users', variables.casoId] 
      });
      queryClient.invalidateQueries({ queryKey: ['casos'] });
      queryClient.invalidateQueries({ queryKey: ['global-share-count'] });
      toast.success('Grupo removido com sucesso');
    },
    onError: () => {
      toast.error('Erro ao remover grupo');
    },
  });
}

export function useUnshareConversationGroupMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      conversationId,
      groupId,
    }: {
      conversationId: string;
      groupId: string;
    }) => {
      const { error } = await supabase
        .from('conversation_group_shares')
        .delete()
        .eq('conversation_id', conversationId)
        .eq('group_id', groupId);

      if (error) throw error;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ 
        queryKey: ['shared-conversation-groups', variables.conversationId] 
      });
      queryClient.invalidateQueries({ 
        queryKey: ['shared-users', variables.conversationId] 
      });
      toast.success('Grupo removido com sucesso');
    },
    onError: () => {
      toast.error('Erro ao remover grupo');
    },
  });
}
